import api, { type CommonResponse } from './base'

export interface DedupAssetFileInfo {
  fileName: string // 数据库中存储的文件名
  dedupPath: string // 文件在 dedup 目录下的相对路径
}

export interface OssPostInfo {
  bucketHost: string // 上传文件的目标 URL
  params: Record<string, string> // 上传表单的字段，例如 OSS 所需的策略信息
}

export interface DedupAssetCheckResponse {
  exists: boolean // 文件是否存在
  fileInfo?: DedupAssetFileInfo // 文件存在时的文件信息
  postInfo?: OssPostInfo // 文件不存在时的上传信息
}

export function check(payload: {
  fileName: string
  md5: string
  size: number
}): Promise<CommonResponse<DedupAssetCheckResponse>> {
  return api.post<unknown, CommonResponse<DedupAssetCheckResponse>>(
    '/v1/dedup-assets/check',
    payload
  )
}
